import { permission } from './permission'
import { constantRouterMap } from './basics.router'
import { createRouter, createWebHashHistory,createWebHistory } from 'vue-router'

let routeList = constantRouterMap;
// 实例化路由
const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes: routeList
})
permission(router)
export default router